// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"screencast"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6 18L2.00099 18L2 3H22L22 18H18","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 21.0003L12.0001 17L16.0001 21L8 21.0003Z","strokeLinecap":"round","strokeWidth":"props.strokeWidth"}}]}]};

const ScreencastIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'screencast',
    ref,
    icon: element,
  },
));

ScreencastIcon.displayName = 'ScreencastIcon';

export default ScreencastIcon;
